import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { getStores } from './actionCreators';
import { initialState, STORES_SLICE_NAME, StoresState } from './models';

export const slice = createSlice({
  name: STORES_SLICE_NAME,
  initialState,
  reducers: {
    resetStoresState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStores.fulfilled, (state: StoresState, action) => {
        state.storeList = action.payload.data;
        state.isLoading = false;
      })
      .addMatcher(isPending(getStores), (state: StoresState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getStores), (state: StoresState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export const { resetStoresState } = slice.actions;

export default slice.reducer;
